<template>
    <div class="module-box">
        <land-contract v-if="moduleId === 1" :tradeSum="tradeSum" />
        <rural-collective-equity v-if="moduleId === 2" :tradeSum="tradeSum" />
        <collective-management v-if="moduleId === 3" :tradeSum="tradeSum" />
        <listing-items v-if="moduleId === 8" />
        <auction-item v-if="moduleId === 9" />
        <transaction-announcement v-if="moduleId === 10" />
    </div>
</template>

<script>
import ListingItems from './ListingItems'
import AuctionItem from './AuctionItem'
import CollectiveManagement from './CollectiveManagement'
import RuralCollectiveEquity from './RuralCollectiveEquity'
import TransactionAnnouncement from './TransactionAnnouncement'
import LandContract from './LandContract'

export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        },
        moduleId: {
            type: Number,
            default: 0
        }
    },
    components: {
        ListingItems, // 挂牌项目
        AuctionItem, // 竞拍项目
        CollectiveManagement, // 集体经营性资产
        LandContract, // 土地承包经营权
        RuralCollectiveEquity, // 集体资源性资产
        TransactionAnnouncement // 成交公告
    }
}
</script>
<style lang="scss" scoped>
.module-box {
    width: 620px !important;
    height: 319px;
    padding-top: 1px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url('../../../assets/images/solid_box.png');
    box-sizing: border-box;
    position: relative;
}
</style>
